import styled from 'styled-components';

export const CommuterSettingsFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 30px;
  margin: 10px;
`;

export const FormItem = styled.div`
  flex: 0 0 calc(33.33% - 20px); /* 33.33% width with a little spacing */
`;

export const SubmitContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin: 15px;
`;

export const InputContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-around;
`;

export const DisabledInputContainer = styled.div`
  gap: 20px;
  display: flex;
  justify-content: space-around;
`;
